import React from 'react'

import {CardHeader, ErrorCard, ErrorPageLayout} from '../pages/errors/ProviderError'

export const UnauthorizedUploadError = () => {

  return <ErrorPageLayout withoutLogo>
    <ErrorCard>
      <CardHeader>
        <h1>This upload page has expired</h1>
      </CardHeader>
      <p>In case you need to be granted access again, please reach out to the person who shared this link with you and ask them to generate a new link.</p>
    </ErrorCard>
  </ErrorPageLayout>
}